import { makeStyles } from '@mui/styles'
import LandingPageBGImage from '../../assets/Images/bglandingpage2x.png'

const useStyles = makeStyles(theme => {
  return ({
    container: {
      background: `url(${LandingPageBGImage})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      minHeight: 'calc(100vh - 114px)',
    },
    displayText: {
      color: '#FFF',
    },
    dividerColor: {
      backgroundColor: '#FEFEFF',
    },
    root: {
      fontSize: '20px',
      color: '#6F6F6F',
      letterSpacing: '0px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingTop: '10px'
    },
    signin: {
      height: '100%',
      maxHeight: '500px',
      width: '100%',
      maxWidth: '400px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: '10px'
    },
    // signinHeading: {
    //   maxHeight: '100px',
    //   height: '100%'
    // },
    linkText: {
      color: '#026AE3',
      textDecoration: 'none'
    },
    helperText: {
      textAlign: 'center',
      color: '#4A4A4A',
      fontSize: '14px'
    }
  })
})

export { useStyles }